import { forwardRef } from 'react'

import { IPortIconTemplate } from '../../../template/iport-icon-template'
import { IconProps } from '../../../types/types'

export const FailedOrderSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<IPortIconTemplate ref={ref} {...props}>
			<path
				d="M21.0007 6.4082H3.60938V12.9734C3.60938 14.6303 4.95252 15.9734 6.60937 15.9734H15.365C16.1493 15.9734 16.8612 15.515 17.1858 14.801L21.0007 6.4082Z"
				fill="#4A4A4A"
			/>
			<path
				d="M4.21739 3.7998H1C1 5.24055 2.16795 6.4085 3.6087 6.4085V13.365C3.6087 14.8058 4.77665 15.9737 6.21739 15.9737V5.7998C6.21739 4.69524 5.32196 3.7998 4.21739 3.7998Z"
				fill="url(#paint0_linear_21008_17504)"
			/>
			<circle cx="13.1747" cy="18.5829" r="1.73913" fill="#4A4A4A" />
			<circle cx="5.34851" cy="18.5829" r="1.73913" fill="#4A4A4A" />
			<circle cx="19" cy="7" r="4" fill="url(#paint1_linear_21008_17504)" />
			<path
				d="M20.8339 5.63964C20.9647 5.50887 20.9647 5.29685 20.8339 5.16607C20.7032 5.0353 20.4911 5.0353 20.3604 5.16607L19 6.52643L17.6396 5.16607C17.5089 5.0353 17.2968 5.0353 17.1661 5.16607C17.0353 5.29685 17.0353 5.50887 17.1661 5.63964L18.5264 7L17.1661 8.36036C17.0353 8.49113 17.0353 8.70315 17.1661 8.83393C17.2968 8.9647 17.5089 8.9647 17.6396 8.83393L19 7.47357L20.3604 8.83393C20.4911 8.9647 20.7032 8.9647 20.8339 8.83393C20.9647 8.70315 20.9647 8.49113 20.8339 8.36036L19.4736 7L20.8339 5.63964Z"
				fill="white"
				stroke="white"
				strokeWidth="0.1"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_21008_17504"
					x1="3.6087"
					y1="3.7998"
					x2="3.6087"
					y2="15.9737"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#568DFE" />
					<stop offset="1" stopColor="#E4EDFC" />
				</linearGradient>
				<linearGradient id="paint1_linear_21008_17504" x1="19" y1="3" x2="19" y2="11" gradientUnits="userSpaceOnUse">
					<stop stopColor="#FF4D4D" />
					<stop offset="1" stopColor="#FF9999" />
				</linearGradient>
			</defs>
		</IPortIconTemplate>
	)
})
